





































































import path from 'path'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Route, RouteConfig } from 'vue-router'
import { omit } from '../../../utils/tool'
import { logout } from '@/api/users'
import { removeCookie } from '@/utils/cookies'

@Component({
  name: 'AsideMenu'
})
export default class extends Vue {
  activeRoute: string = ''
  menuIconClass: any = {
    '/content': 'far fa-receipt',
    '/files': 'far fa-cubes',
    '/user': 'far fa-users',
    '/developer': 'far fa-file-signature',
    // '/approval': 'far fa-calculator',
    '/approval': 'far fa-tasks',
    '/payment': 'far fa-box-usd',
    '/trade': 'far fa-crown',
    '/trade-android': 'far fa-crown',
    '/good-price': 'far fa-credit-card',
    '/permission': 'far fa-cog fa-fw',
    '/feedback': 'far fa-comment-dots',
    '/datas': 'far fa-rocket',
    '/production': 'fa fa-production'
  }

  submenu: any[] = []

  title: string = ''

  userInfo: any = {}

  homePage: any = {
    path: '/home'
  }

  avatar: string = ''
  userName: string = ''
  token: string = ''

  getUserInfo() {
    const userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      let obj = JSON.parse(userInfo)
      const { image: avatar, userName, token } = obj
      this.avatar = avatar
      this.userName = userName
      this.token = token
      this.userInfo = userInfo
    }
  }

  handleOpen(route: string, index: number) {
    if (route) {
      if (route) {
        this.$router.push(route)
      }
    } else {
      this.$router.push({
        path: '/home'
      })
    }
  }

  handleRouteChange() {
    let path: string = this.$route.matched[0].path
    if (path.length > 0) {
      let matchedRoute: any = this.routes.find((route: any) => route.path === path)
      if (matchedRoute) {
        // console.log(matchedRoute)
        this.activeRoute = path
        this.submenu = matchedRoute.children || []
        // console.log(matchedRoute.meta)
        this.title = matchedRoute.meta.title
      }
    } else {
      this.activeRoute = ''
      this.submenu = []
      this.title = '概述'
    }
  }

  private async logout() {
    let res: any = await logout({ token: this.token })
    if (res.status.code === 0) {
      // 退出成功, 清空相应信息
      removeCookie('token')
      localStorage.removeItem('userInfo')
      this['$router'].push(`/login?redirect=${this.$route.fullPath}`)
    } else {
      this['$message'].error('登出失败!')
    }
  }

  get routes() {
    let secondRoutes: RouteConfig[] = (this.$router as any).options.routes
    // 生成只有二级的路由表
    let tempRoutes: RouteConfig[] = JSON.parse(JSON.stringify(secondRoutes))
    tempRoutes.forEach((item) => {
      if (item.children) {
        item.children.forEach((item1) => {
          if (item1.children) {
            omit(item1 as any, ['children'])
          }
        })
      }
    })
    return tempRoutes.filter((item: any) => item.meta && item.meta.title)
  }

  created() {
    this.handleRouteChange()
    this.getUserInfo()
  }

  private resolvePath(routePath: string) {
    return path.resolve(this.activeRoute, routePath)
  }

  @Watch('$route')
  private onRouteChange() {
    this.handleRouteChange()
  }
}
